import { z } from "zod";

export const sendI9OnboardingLinkRequestSchema = z.object({
  employeeID: z.string(),
});

export type TSendI9OnboardingLinkRequest = z.infer<
  typeof sendI9OnboardingLinkRequestSchema
>;
